import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { RequestAction, ResponseAction } from './actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { RollinService } from 'src/app/services/rollin.service';

@Injectable()
export class SuperannuationProviderSearchEffects {
  constructor(private actions$: Actions,
    public toastr: ToastrService,
    private service: RollinService) {
  }

  providerSearch$ = createEffect(() => this.actions$.pipe(
    ofType(RequestAction),
    switchMap((action: any) => this.service.providerSearch(action.data).pipe(
      map((data: any) => {
        return ResponseAction({ payload: data.data });
      }),
      catchError(_err => {
        return EMPTY;
      })
    )),
  ));

}
